import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

import {
  GET_HOMEPAGE,
  GET_MOSTLY_VIEW,
  GET_LATEST,
  GET_TOP_COLLECTIONS,
  GET_EXPLORE,
  GET_SECONDRY_SALE,
  POST_FOLLOW,
  GET_FOLLOW,
  GET_BLOGS,
  GET_BLOGS_BY_ID,
} from "./actionTypes";
import {
  getHomepageFail,
  getHomepageSuccess,
  getMostlyViewFail,
  getMostlyViewSuccess,
  getLatestFail,
  getLatestSuccess,
  getTopCollectionsFail,
  getTopCollectionsSuccess,
  getExploreFail,
  getExploreSuccess,
  getSecondrySaleFail,
  getSecondrySaleSuccess,
  postFollowFail,
  postFollowSuccess,
  getFollowFail,
  getFollowSuccess,
  getBlogsByIdFail,
  getBlogsFail,
  getBlogsSuccess,
  getBlogsByIdSuccess,
} from "./actions";

import {
  getHomepage,
  getMostlyView,
  getLatest,
  getTopCollections,
  getBlogs,
  getExplore,
  getSecondrySale,
  getBlogsById,
  postFollow,
  getFollow,
} from "helpers/backend_helper";

function* onGetHomePage({ payload: { data, callback } }) {
  try {
    const response = yield call(getHomepage, data);

    if (response.status === "failure") {
      return yield put(getHomepageFail(response.message));
    }

    callback && callback(response);
    yield put(getHomepageSuccess(response.data));
  } catch (error) {
    yield put(getHomepageFail(""));
  }
}

function* onGetMostlyView({ payload: { data, callback } }) {
  try {
    const response = yield call(getMostlyView, data);

    if (response.status === "failure") {
      return yield put(getMostlyViewFail(response.message));
    }

    callback && callback(response);
    yield put(getMostlyViewSuccess(response));
  } catch (error) {
    yield put(getMostlyViewFail(""));
  }
}

function* onGetLatest({ payload: { data, callback } }) {
  try {
    const response = yield call(getLatest, data);

    if (response.status === "failure") {
      return yield put(getLatestFail(response.message));
    }

    callback && callback(response);
    yield put(getLatestSuccess(response));
  } catch (error) {
    yield put(getLatestFail(""));
  }
}

function* onGetTopCollections({ payload: { data, callback } }) {
  try {
    const response = yield call(getTopCollections, data);

    if (response.status === "failure") {
      return yield put(getTopCollectionsFail(response.message));
    }

    callback && callback(response);
    yield put(getTopCollectionsSuccess(response));
  } catch (error) {
    yield put(getTopCollectionsFail(""));
  }
}

function* onGetExplore({ payload: { data, callback } }) {
  try {
    const response = yield call(getExplore, data);

    if (response.status === "failure") {
      return yield put(getExploreFail(response.message));
    }

    callback && callback(response);
    yield put(getExploreSuccess(response));
  } catch (error) {
    yield put(getExploreFail(""));
  }
}

function* onGetSecondrySale({ payload: { data, callback } }) {
  try {
    const response = yield call(getSecondrySale, data);

    if (response.status === "failure") {
      return yield put(getSecondrySaleFail(response.message));
    }

    callback && callback(response);
    yield put(getSecondrySaleSuccess(response));
  } catch (error) {
    yield put(getSecondrySaleFail(""));
  }
}

function* onPostFollow({ payload: { data, callback } }) {
  try {
    const response = yield call(postFollow, data);
    callback && callback(response);
    if (response.status === "failure") {
      return yield put(postFollowFail(response.message));
    }

    yield put(postFollowSuccess(response));
  } catch (error) {
    yield put(postFollowFail(""));
  }
}

function* onGetFollow({ payload: { data, callback } }) {
  try {
    const response = yield call(getFollow, data);

    if (response.status === "failure") {
      return yield put(getFollowFail(response.message));
    }

    callback && callback(response);
    yield put(getFollowSuccess(response));
  } catch (error) {
    yield put(getFollowFail(""));
  }
}

function* onGetBlogs({ payload: { data, callback } }) {
  try {
    const response = yield call(getBlogs, data);

    if (response.status === "failure") {
      return yield put(getBlogsFail(response.message));
    }

    callback && callback(response);
    yield put(getBlogsSuccess(response.data));
  } catch (error) {
    yield put(getBlogsFail(""));
  }
}
function* onGetBlogById({ payload: { data, callback } }) {
  try {
    const response = yield call(getBlogsById, data);
    if (response.status === "failure") {
      return yield put(getBlogsByIdFail(response.message));
    }
    yield put(getBlogsByIdSuccess(response.data));
    callback && callback(response.data);
  } catch (error) {
    yield put(getBlogsByIdFail("Internal Error"));
  }
}
function* homeSaga() {
  yield takeEvery(GET_HOMEPAGE, onGetHomePage);
  yield takeEvery(GET_MOSTLY_VIEW, onGetMostlyView);
  yield takeEvery(GET_LATEST, onGetLatest);
  yield takeEvery(GET_TOP_COLLECTIONS, onGetTopCollections);
  yield takeLatest(GET_EXPLORE, onGetExplore);
  yield takeLatest(GET_SECONDRY_SALE, onGetSecondrySale);
  yield takeEvery(POST_FOLLOW, onPostFollow);
  yield takeEvery(GET_FOLLOW, onGetFollow);
  yield takeEvery(GET_BLOGS, onGetBlogs);
  yield takeEvery(GET_BLOGS_BY_ID, onGetBlogById);
}

export default homeSaga;
